export default "__VITE_ASSET__DKOdOHI2__"